import { render, staticRenderFns } from "./PostcodeSelector.vue?vue&type=template&id=90b4382e&scoped=true&"
import script from "./PostcodeSelector.vue?vue&type=script&lang=js&"
export * from "./PostcodeSelector.vue?vue&type=script&lang=js&"
import style0 from "./PostcodeSelector.vue?vue&type=style&index=0&id=90b4382e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b4382e",
  null
  
)

export default component.exports